import { jsxs as b, jsx as t, Fragment as P } from "react/jsx-runtime";
import { useRef as j, useState as I, useEffect as y } from "react";
import { createPortal as F } from "react-dom";
import { u as n } from "./index-6a632112.mjs";
import { Q as c, s as i, p as U, r as l, a as W, d as S, h as T, c as C, B as R, e as N } from "./themes-5f0b3c3d.mjs";
import { l as B } from "./lineHeights-72d3110c.mjs";
import { z as D } from "./zIndices-d07533f3.mjs";
import { CloseButton as q } from "./closeButton.js";
import { m as E, A as K } from "./index-c8707610.mjs";
import { a as X, b as G } from "./superScript-393c70dc.mjs";
import { Disclosures as Q } from "./disclosure.js";
import { useAccessibilityProps as V } from "./accessibility.js";
import { h as J } from "./hTag-40b23797.mjs";
import { Button as L } from "./button.js";
const Y = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, Z = n.div`
  background-color: ${(e) => e.bgOverlayColor};
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
`, _ = n.div`
  height: 100vh;
  grid-column: 1 / -1;
  @media ${c.tabletAndUp} {
    ${({ variant: e }) => {
  switch (e) {
    case "large":
      return "grid-column: 1/ span 8;";
    case "medium":
      return "grid-column: 2/ span 6;";
    case "small":
      return "grid-column: 3/ span 4;";
  }
}}
  }
  @media ${c.laptopAndUp} {
    ${({ variant: e }) => {
  switch (e) {
    case "large":
      return "grid-column: 2/ span 10;";
    case "medium":
      return "grid-column: 4/ span 6;";
    case "small":
      return "grid-column: 5/ span 4;";
  }
}}
  }
`, O = n.div`
  display: grid;
  grid-gap: ${i["6x"]};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 70%;
  left: 0;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(4, 1fr);
  z-index: ${D.modal};

  @media ${c.tabletAndUp} {
    grid-template-columns: repeat(8, 1fr);
    top: 50%;
  }
  @media ${c.laptopAndUp} {
    grid-template-columns: repeat(12, 1fr);
  }
`, ee = n(E.div)`
  display: grid;
  font-family: ${U};
  background: ${(e) => e.theme.components.modalWindow.modalWindowBackground};
  color: ${(e) => e.theme.components.modalWindow.modalWindowColor};
  box-shadow: 0 4px 12px 0px rgba(0, 0, 0, 0.12);
  min-width: calc(100vw - 64px);

  padding: ${i["4x"]} ${i["8x"]} ${i["8x"]} ${i["8x"]};
  gap: ${i["6x"]};
  position: fixed;

  ${({ variant: e }) => {
  switch (e) {
    case "large":
      return `min-height:calc(${window.innerHeight}px - 35%);
                border-top-left-radius: ${l["4x"]};
                border-top-right-radius: ${l["4x"]};
                bottom: 0;`;
    case "medium":
      return `min-height:35%;
                border-top-left-radius: ${l["4x"]};
                border-top-right-radius: ${l["4x"]};
                bottom: 0;`;
    case "small":
      return `min-height:250px;
                border-radius: ${l["4x"]};
                bottom: 25%;`;
  }
}}

  @media ${c.tabletAndUp} {
    position: static;
    min-height: 250px;
    border-radius: ${l["4x"]};
    min-width: inherit;
  }
  @media ${c.laptopAndUp} {
    position: static;
    min-height: 275px;
    border-radius: ${l["4x"]};
  }
`, te = n.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`, oe = n.div`
  display: flex;
  justify-content: space-between;
`, ne = n.h1`
  ${Y()}
  font-size: ${W.xxxxlarge};
  font-family: ${S.headline};
  font-style: normal;
  font-weight: ${T.XL.fontWeight};
  line-height: ${B.xxlarge};
`, ie = n.div`
  display: flex;
  align-items: center;
  @media ${c.mobile} {
    position: relative;
    top: -70px;
    color: ${C.brandTwilight[0]};
  }
`, re = ({
  children: e,
  onClose: o,
  hasClose: a = !0,
  ...u
}) => /* @__PURE__ */ b(oe, { ...u, children: [
  /* @__PURE__ */ t(ne, { children: e }),
  /* @__PURE__ */ t(ie, { children: a && /* @__PURE__ */ t(q, { onClick: o, size: "large" }) })
] }), ae = n.div`
  padding: 24px 0px;
`, de = ({ children: e, ...o }) => /* @__PURE__ */ t(ae, { ...o, children: e }), le = n.div`
  display: flex;
  justify-content: ${(e) => e.placement === "left" ? "flex-start" : e.placement === "right" ? "flex-end" : "center"};
  @media ${c.mobile} {
    flex-direction: column;
    width: 100%;
  }
`, se = ({
  children: e,
  placement: o = "left",
  ...a
}) => /* @__PURE__ */ t(le, { placement: o, ...a, children: e }), H = ({
  isOpen: e,
  onClose: o,
  variant: a = "medium",
  children: u,
  bgOverlayColor: h = "rgba(0, 0, 0, 0.3)",
  ...p
}) => {
  const $ = j(null), [v, d] = I(!1), A = v ? {
    open: { y: "0%" },
    closed: { y: "30%" }
  } : {
    open: { y: "-60%" },
    closed: { y: "-50%" }
  };
  y(() => {
    const s = () => {
      d(window.innerWidth < R.tabletMin);
    };
    return s(), window.addEventListener("resize", s), () => window.removeEventListener("resize", s);
  }, [e]), y(() => {
    const s = (r) => {
      e && !$.current.contains(r.target) && o && o();
    };
    return document.addEventListener("mousedown", s), () => {
      document.removeEventListener("mousedown", s);
    };
  }), y(() => {
    if (e) {
      const f = document.getElementById("modal-container");
      f?.setAttribute("tabindex", "-1"), f?.focus(), document.body.style.overflow = "hidden";
    } else
      document.body.style.overflow = "";
    const s = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', r = document.querySelector("#modal-container"), m = r?.querySelectorAll(
      s
    )[0], x = r?.querySelectorAll(s), w = x && x[x.length - 1], M = (f) => {
      f.key === "Tab" && (f.shiftKey ? document.activeElement === m && (w?.focus(), f.preventDefault()) : document.activeElement === w && (m?.focus(), f.preventDefault()));
    };
    return m?.focus(), e && document.addEventListener("keydown", M), () => {
      document.removeEventListener("keydown", M);
    };
  }, [e]);
  const k = (s) => {
    s.key === "Escape" && o && o();
  };
  return F(
    /* @__PURE__ */ t(K, { children: e && /* @__PURE__ */ b(
      E.div,
      {
        className: "overlay",
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        children: [
          e && /* @__PURE__ */ t(
            Z,
            {
              "aria-label": "modal-window-overlay",
              onClick: o,
              bgOverlayColor: h
            }
          ),
          /* @__PURE__ */ t(O, { children: /* @__PURE__ */ t(_, { variant: a, children: /* @__PURE__ */ t(
            ee,
            {
              initial: "closed",
              animate: e ? "open" : "closed",
              exit: "closed",
              variants: A,
              transition: { duration: 0.3 },
              role: "dialog",
              isOpen: e,
              onKeyDown: k,
              variant: a,
              ref: $,
              id: "modal-container",
              ...p,
              children: /* @__PURE__ */ t(te, { children: u })
            }
          ) }) })
        ]
      }
    ) }),
    document.body
  );
};
H.ModalHeader = re;
H.ModalBody = de;
H.ModalFooter = se;
const ce = n.div`
  background-color: ${(e) => e.$bgOverlayColor};
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  z-index: ${D.modalOverlay};
`, me = n.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${D.modal};
`, ue = n.div`
  ${X()}
  ${G()}
  height: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding-top: ${i["14x"]};

  ${({ $variant: e }) => {
  switch (e) {
    case "large":
      return "align-items: flex-end;";
    case "medium":
      return "align-items: flex-end;";
    case "small":
      return `
          align-items: center;
          padding: 50px ${i["5x"]};
        `;
  }
}}

  @media ${c.tabletAndUp} {
    align-items: center;
    padding: 50px ${i["5x"]};
  }
`, pe = n(E.div)`
  font-family: ${U};
  background: ${(e) => e.theme.components.modalWindow.modalWindowBackground};
  color: ${(e) => e.theme.components.modalWindow.modalWindowColor};
  box-shadow: 0 4px 12px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 100%;
  padding: ${i["4x"]} ${i["8x"]} ${i["8x"]} ${i["8x"]};
  gap: ${i["6x"]};
  box-sizing: border-box;
  height: 100%;

  ${({ $variant: e }) => {
  switch (e) {
    case "large":
      return `
          border-top-left-radius: ${l["4x"]};
          border-top-right-radius: ${l["4x"]};
        `;
    case "medium":
      return `
          border-top-left-radius: ${l["4x"]};
          border-top-right-radius: ${l["4x"]};
        `;
    case "small":
      return `
          border-radius: ${l["4x"]};
        `;
  }
}}

  @media ${c.tabletAndUp} {
    border-radius: ${l["4x"]};
    ${({ $variant: e }) => {
  switch (e) {
    case "large":
      return "max-width: 794px;";
    case "medium":
      return "max-width: 590px;";
    case "small":
      return "max-width: 384px;";
  }
}}
  }
  @media ${c.laptopAndUp} {
    border-radius: ${l["4x"]};
    ${({ $variant: e }) => {
  switch (e) {
    case "large":
      return "max-width: 1016px;";
    case "medium":
      return "max-width: 600px;";
    case "small":
      return "max-width: 392px;";
  }
}}
  }
`, fe = n.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: ${i["6x"]};
`, he = n.div`
  display: flex;
  justify-content: space-between;
  position: relative;
`, ge = n(J)`
  font-size: ${W.xxxxlarge};
  font-family: ${S.headline};
  font-style: normal;
  font-weight: ${T.XL.fontWeight};
  line-height: ${B.xxlarge};
`, xe = n.div`
  display: flex;
  align-items: center;
  @media ${c.mobile} {
    position: absolute;
    top: -68px;
    right: -${i["3x"]};
    color: ${C.brandTwilight[0]};
    &:hover {
      color: ${C.brandTwilight[1e3]};
    }
  }
`, qe = ({
  children: e,
  onClose: o,
  hasClose: a = !0,
  id: u,
  headingLevel: h = "h1",
  idProps: p,
  accessibilityOptions: $,
  ...v
}) => /* @__PURE__ */ b(he, { ...v, children: [
  /* @__PURE__ */ t(ge, { id: u, as: h, children: e }),
  /* @__PURE__ */ t(xe, { children: a && /* @__PURE__ */ t(
    q,
    {
      id: p?.closeButtonId,
      onClick: o,
      size: "large",
      ...$
    }
  ) })
] }), ye = n.div`
  height: 100%;
  overflow-y: auto;
  font-size: ${W.small};
  font-family: ${S.body};
  font-style: normal;
  font-weight: ${N.regular.L.fontWeight};
  line-height: ${B.medium};
  width: calc(100% + ${i["3x"]});
  padding-right: ${i["3x"]};
  box-sizing: border-box;
`, Ke = ({ children: e, ...o }) => /* @__PURE__ */ t(ye, { "data-id": "modal-body", ...o, children: e }), be = n.div`
  display: flex;
  justify-content: ${(e) => e.$placement === "left" ? "flex-start" : e.$placement === "right" ? "flex-end" : "center"};

  width: 100%;
  flex-wrap: wrap;
  row-gap: ${i["2x"]};
`, Pe = ({
  children: e,
  placement: o = "left",
  ...a
}) => /* @__PURE__ */ t(be, { $placement: o, ...a, children: e }), Ie = ({
  isOpen: e,
  onClose: o,
  variant: a = "medium",
  children: u,
  bgOverlayColor: h = "rgba(0, 0, 0, 0.3)",
  disclosures: p,
  accessibilityOptions: $ = {},
  ...v
}) => {
  const d = j(null), A = V("dialog", {
    ariaModal: !0,
    ...$
  });
  y(() => {
    const r = (m) => {
      e && !d.current.contains(m.target) && o && o();
    };
    return document.addEventListener("mousedown", r), () => {
      document.removeEventListener("mousedown", r);
    };
  }), y(() => {
    const r = () => {
      if (d?.current) {
        const m = d.current?.querySelector(
          'div[data-id="modal-body"]'
        );
        d.current?.removeAttribute("style"), m?.clientHeight >= m?.scrollHeight && d.current?.setAttribute("style", "height: auto");
      }
    };
    return r(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [e]), y(() => {
    if (d?.current) {
      const r = d.current?.querySelector(
        'div[data-id="modal-body"]'
      );
      d.current?.removeAttribute("style"), r?.clientHeight >= r?.scrollHeight && d.current?.setAttribute("style", "height: auto");
    }
  }, [u]), y(() => {
    if (e) {
      const g = document.getElementById("modal-container");
      if (g?.setAttribute("tabindex", "-1"), g?.focus(), document.body.style.overflow = "hidden", d?.current) {
        const z = d.current?.querySelector(
          'div[data-id="modal-body"]'
        );
        z?.clientHeight >= z?.scrollHeight && d.current?.setAttribute("style", "height: auto");
      }
    } else
      document.body.style.overflow = "";
    const r = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', m = document.querySelector("#modal-container"), x = m?.querySelectorAll(
      r
    )[0], w = m?.querySelectorAll(r), M = w && w[w.length - 1], f = (g) => {
      g.key === "Tab" && (g.shiftKey ? document.activeElement === x && (M?.focus(), g.preventDefault()) : document.activeElement === M && (x?.focus(), g.preventDefault()));
    };
    return x?.focus(), e && document.addEventListener("keydown", f), () => {
      document.removeEventListener("keydown", f);
    };
  }, [e]);
  const k = (r) => {
    r.key === "Escape" && o && o();
  }, s = {
    closed: { opacity: 0 },
    open: { opacity: 1 }
  };
  return F(
    /* @__PURE__ */ t(K, { children: e && /* @__PURE__ */ b(E.div, { className: "overlay", children: [
      e && /* @__PURE__ */ t(
        ce,
        {
          "aria-label": "modal-window-overlay",
          onClick: o,
          $bgOverlayColor: h
        }
      ),
      /* @__PURE__ */ t(me, { children: /* @__PURE__ */ t(ue, { $variant: a, children: /* @__PURE__ */ b(
        pe,
        {
          initial: "closed",
          animate: e ? "open" : "closed",
          exit: "closed",
          variants: s,
          transition: { duration: 0.3 },
          isOpen: e,
          onKeyDown: k,
          $variant: a,
          ref: d,
          id: "modal-container",
          ...A,
          ...v,
          children: [
            /* @__PURE__ */ t(fe, { children: u }),
            p && /* @__PURE__ */ t(
              Q,
              {
                disclosureContent: p?.disclosureContent,
                id: p?.id,
                className: p?.className,
                disclosureTitleColor: p?.disclosureTitleColor,
                style: p?.style
              }
            )
          ]
        }
      ) }) })
    ] }) }),
    document.body
  );
}, $e = n.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  grid-column: 1 / span 6;
  grid-row: 1;
`, we = n.div`
  font-weight: ${T.XL.fontWeight};
  font-size: ${W.large};
  text-align: left;
`, ve = n.div`
  font-size: ${W.large};
  text-align: left;
  width: 100%;
  grid-column: 1 / span 6;
`, Me = n.div`
  grid-column: 1 / span 6;
  width: 100%;
`, We = n.div`
  display: flex;
  padding-top: ${i["6x"]};
  justify-content: ${(e) => e.secondaryButtonLabel ? "space-around" : "left"};
`, Re = ({
  title: e = "Modal Window",
  primaryButtonLabel: o = "Dismiss",
  secondaryButtonLabel: a,
  children: u,
  handleModal: h
}) => /* @__PURE__ */ b(P, { children: [
  /* @__PURE__ */ t($e, { children: /* @__PURE__ */ t(we, { children: e }) }),
  /* @__PURE__ */ t(ve, { children: u }),
  /* @__PURE__ */ t(Me, { children: /* @__PURE__ */ b(We, { secondaryButtonLabel: a, children: [
    /* @__PURE__ */ t(L, { onClick: h, children: o }),
    a && /* @__PURE__ */ t(L, { variant: "outline", onClick: h, children: a })
  ] }) })
] });
export {
  H as D,
  Ie as M,
  qe as a,
  Ke as b,
  Pe as c,
  Re as d
};
